import { API_BASE_URL } from '../../../../api';
import React, { useState, useContext } from 'react';
import './EditCitation.style.scss';
// import { DayPicker } from 'react-day-picker';
// import 'react-day-picker/dist/style.css';
import { AccountContext } from '../../../../Contexts/main.context';
import CreateFollowUp from '../../../Universal/CreateFollowUp/CreateFollowUp.component';





const EditCitationModal = ({ citation, onClose, onDelete }) => {

     const context = useContext(AccountContext);
     const { activeClient, } = context || {};

     // these are both needed for the CreateFollowUp component
     const [showModal, setShowModal] = useState(false);
     const [currentDateValue, setCurrentDate] = useState(new Date());
     //

     const [formData, setFormData] = useState({
          ...citation,
          URLStatus: citation.URLStatus || 'unverified',
     });

     const [copyClicked, setCopyClicked] = useState('');
     const [isDeleting, setIsDeleting] = useState(false);
     const [deleteError, setDeleteError] = useState('');
     const [isSaving, setIsSaving] = useState(false);


     // const handleChange = (e) => {
     //      const { name, value } = e.target;
     //      setFormData(prev => ({ ...prev, [name]: value }));
     // };

     const handleSave = async () => {
          if (isSaving || isDeleting) return;
          setDeleteError('');
          setIsSaving(true);
          try {
               // Verification timestamps are maintained by the server, not the editor.
               const { URLCheckedAt, ...editableData } = formData;
               const response = await fetch(API_BASE_URL + 'special.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ ...editableData, script: 'updateCitation' }),
               });
               let result;
               try {
                    result = await response.json();
               } catch {
                    throw new Error('The server returned an invalid response. Please try again. If it continues, check the server log.');
               }
               if (!response.ok || result.success !== true) throw new Error(result.error || 'Unable to save citation.');
               onClose();
          } catch (error) {
               setDeleteError(error.message || 'Unable to save citation.');
          } finally {
               setIsSaving(false);
          }
     };


     const handleDelete = async () => {
          if (isDeleting || isSaving || !window.confirm(`Permanently delete the citation for ${citation.Domain || 'this site'}? This cannot be undone.`)) {
               return;
          }

          setDeleteError('');
          setIsDeleting(true);
          try {
               const response = await fetch(API_BASE_URL + 'special.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                         script: 'deleteCitation',
                         ID: citation.ID,
                         clientID: citation.clientID || activeClient?.ID,
                    }),
               });
               const result = await response.json();
               if (!response.ok || result.success !== true) {
                    throw new Error(result.error || 'Unable to delete the citation. Please try again.');
               }
               if (onDelete) onDelete(citation.ID);
               else onClose();
          } catch (error) {
               setDeleteError(error.message || 'Unable to delete the citation. Please try again.');
          } finally {
               setIsDeleting(false);
          }
     };

     const handleCopy = (fieldName, value) => {
          navigator.clipboard.writeText(value)
               .then(() => {
                    setCopyClicked(fieldName);
               })
               .catch(err => {
                    console.error('Failed to copy:', err);
               });
     };

     const fillDataFromAccount = () => {
          setFormData(prev => ({
               ...prev,
               BusinessName: activeClient.companyName || '',
               cistationAddress: activeClient.address || '',
               PostalCode: activeClient.postal || '',
               PhoneNumber: activeClient.phone || '',
          }));
     };

     const verifyNAPData = () => {
          alert('This will Check NAP Data once Trevor Approves New API for Searching. Pressing any of the Verify will Verify Each of the 4 NAP Fields');
     }



     // const ignoreList = ["DomainAuthority", "KeyCitation", "TypeOfSite", "FreePaidListing", "ID", "ClientID", "CompetitorsWithCitations", "AlternativeBusinessName", "GeneralStatus", "BusinessName"]; // Add any other keys you want to ignore

     return (
          <div className="custom-modal-backdrop">
               <div className="container alert-light p-4 rounded">
                    <div className="bg-navy p-3 mb-3 d-flex justify-content-center">
                         <h5 className="text-center text-lemon fw-bold">Citation Information</h5>
                    </div>

                    {formData && (
                         <>
                              {/* Row 1 */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Status</label>
                                        <select
                                             className="form-control"
                                             name="citationStatus"
                                             value={formData.citationStatus}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationStatus: e.target.value }))
                                             }
                                        >
                                             <option value="active">Active</option>
                                             <option value="edit">Edit</option>
                                             <option value="dead">Dead</option>
                                             <option value="pending">Pending</option>
                                        </select>
                                   </div>


                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Domain</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="Domain"
                                             value={formData.Domain}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, Domain: e.target.value }))
                                             }
                                        />
                                   </div>
                              </div>

                              {/* Row 2 (add more fields here) */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Citation Date</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="citationYear"
                                             value={formData.citationYear}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationYear: e.target.value }))
                                             }
                                        />
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="citationMonth"
                                             value={formData.citationMonth}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationMonth: e.target.value }))
                                             }
                                        />
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="citationDay"
                                             value={formData.citationDay}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationDay: e.target.value }))
                                             }
                                        />
                                   </div>

                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Citation Value</label>
                                        <select
                                             className="form-control"
                                             name="CitationValue"
                                             value={formData.CitationValue}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, CitationValue: e.target.value }))
                                             }
                                        >
                                             <option value="Very High">Very High</option>
                                             <option value="High">High</option>
                                             <option value="Medium">Medium</option>
                                             <option value="Low">Low</option>
                                             <option value="Unknown">Unknown</option>
                                        </select>
                                   </div>
                              </div>

                              {/* Row 3 (add more fields here) */}
                              <div className="row g-3 mb-3">

                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Business Name</label>
                                        <div className="col-24">
                                             <input
                                                  className="form-control"
                                                  type="text"
                                                  name="BusinessName"
                                                  value={formData.BusinessName}
                                                  onChange={(e) =>
                                                       setFormData(prev => ({ ...prev, BusinessName: e.target.value }))
                                                  }
                                             />
                                        </div>
                                        <div className="flex-grow-1 alert-success">
                                             <div className="btn btn-primary w-100" onClick={() => fillDataFromAccount()}>Complete</div>
                                        </div>

                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Nap Problem</label>
                                        <div className="col-24">
                                             <select
                                                  className={`form-control ${formData.BusinessNameIssue?.toLowerCase() === 'yes' ? 'is-invalid' : ''}`}
                                                  aria-label="Business name NAP problem"
                                                  name="BusinessNameIssue"
                                                  value={formData.BusinessNameIssue && formData.BusinessNameIssue.toLowerCase() !== 'no' ? 'Yes' : ''}
                                                  onChange={e => setFormData(prev => ({ ...prev, BusinessNameIssue: e.target.value }))}
                                             >
                                                  <option value="">No</option>
                                                  <option value="Yes">Yes</option>
                                             </select>
                                        </div>
                                        <div className="flex-grow-1">
                                             <div className="btn btn-primary w-100" onClick={() => verifyNAPData()}>Verify</div>
                                        </div>

                                   </div>
                              </div>
                              {/* Row 4 (add more fields here) */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Business Address</label>
                                        <input
                                             className={`form-control`}
                                             type="text"
                                             name="cistationAddress"
                                             value={formData.cistationAddress}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, cistationAddress: e.target.value }))
                                             }
                                        />
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Nap Problem</label>
                                        <div className="col-24">
                                             <select
                                                  className={`form-control ${formData.Address_Issue?.toLowerCase() === 'yes' ? 'is-invalid' : ''}`}
                                                  aria-label="Address NAP problem"
                                                  name="Address_Issue"
                                                  value={formData.Address_Issue && formData.Address_Issue.toLowerCase() !== 'no' ? 'Yes' : ''}
                                                  onChange={e => setFormData(prev => ({ ...prev, Address_Issue: e.target.value }))}
                                             >
                                                  <option value="">No</option>
                                                  <option value="Yes">Yes</option>
                                             </select>
                                        </div>
                                        <div className="flex-grow-1">
                                             <div className="btn btn-primary w-100" onClick={() => verifyNAPData()}>Verify</div>
                                        </div>
                                   </div>
                              </div>
                              {/* Row 5 (add more fields here) */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Postal Code</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="PostalCode"
                                             value={formData.PostalCode}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, PostalCode: e.target.value }))
                                             }
                                        />
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Nap Problem</label>
                                        <div className="col-24">
                                             <select
                                                  className={`form-control ${formData.PostalCodeIssue?.toLowerCase() === 'yes' ? 'is-invalid' : ''}`}
                                                  aria-label="Postal code NAP problem"
                                                  name="PostalCodeIssue"
                                                  value={formData.PostalCodeIssue && formData.PostalCodeIssue.toLowerCase() !== 'no' ? 'Yes' : ''}
                                                  onChange={e => setFormData(prev => ({ ...prev, PostalCodeIssue: e.target.value }))}
                                             >
                                                  <option value="">No</option>
                                                  <option value="Yes">Yes</option>
                                             </select>
                                        </div>
                                        <div className="flex-grow-1">
                                             <div className="btn btn-primary w-100" onClick={() => verifyNAPData()}>Verify</div>
                                        </div>
                                   </div>
                              </div>
                              {/* Row 6 (add more fields here) */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Phone Number</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="PhoneNumber"
                                             value={formData.PhoneNumber}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, PhoneNumber: e.target.value }))
                                             }
                                        />
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Nap Problem</label>
                                        <div className="col-24">
                                             <select
                                                  className={`form-control ${formData.PhoneNumberIssue?.toLowerCase() === 'yes' ? 'is-invalid' : ''}`}
                                                  aria-label="Phone number NAP problem"
                                                  name="PhoneNumberIssue"
                                                  value={formData.PhoneNumberIssue && formData.PhoneNumberIssue.toLowerCase() !== 'no' ? 'Yes' : ''}
                                                  onChange={e => setFormData(prev => ({ ...prev, PhoneNumberIssue: e.target.value }))}
                                             >
                                                  <option value="">No</option>
                                                  <option value="Yes">Yes</option>
                                             </select>
                                        </div>
                                        <div className="flex-grow-1">
                                             <div className="btn btn-primary w-100" onClick={() => verifyNAPData()}>Verify</div>
                                        </div>
                                   </div>
                              </div>
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label htmlFor="citation-url-status" className="col-12 text-end pe-3 fw-bold">Link Status</label>
                                        <select id="citation-url-status" name="URLStatus" className="form-control" value={formData.URLStatus}
                                             onChange={e => setFormData(prev => ({ ...prev, URLStatus: e.target.value }))}>
                                             <option value="unverified">Unverified</option>
                                             <option value="ok">Working</option>
                                             <option value="not_found">404 Error</option>
                                             {formData.URLStatus === 'missing' && <option value="missing" disabled>No URL</option>}
                                             <option value="error">Could not verify</option>
                                        </select>
                                   </div>
                              </div>
                              {/* Row 7 (add more fields here) */}
                              <div className="row g-3 mb-3">
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Citation Link</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="CitationLink"
                                             value={formData.CitationLink}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, CitationLink: e.target.value }))
                                             }
                                        />
                                        <div
                                             className={`btn ${copyClicked === 'CitationLink' ? 'btn-warning' : 'btn-navy'}`}
                                             onClick={() => handleCopy('CitationLink', formData.CitationLink)}
                                        >
                                             Copy
                                        </div>
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Citation Site</label>
                                        <select
                                             className="form-control"
                                             name=" source"
                                             value={formData.source !== 'Monday' ? 'BrightLocal' : 'Monday'}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, source: e.target.value }))
                                             }
                                        >
                                             <option value="BrightLocal">Bright Local</option>
                                             <option value="Monday">Monday.com</option>
                                        </select>
                                   </div>
                              </div>

                              {/* Row 8 (Citation User Info) */}
                              <div className="d-flex g-3 mb-3 flex-wrap alert-navy p-3">
                                   <div className="col-24 d-flex align-items-center gap-2 mb-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">User</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="citationUser"
                                             value={formData.citationUser}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationUser: e.target.value }))
                                             }
                                        />
                                        <div
                                             className={`btn ${copyClicked === 'citationUser' ? 'btn-warning' : 'btn-navy'}`}
                                             onClick={() => handleCopy('citationUser', formData.citationUser)}
                                        >
                                             Copy
                                        </div>
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2 mb-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Pass</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="citationPass"
                                             value={formData.citationPass}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationPass: e.target.value }))
                                             }
                                        />
                                        <div
                                             className={`btn ${copyClicked === 'citationPass' ? 'btn-warning' : 'btn-navy'}`}
                                             onClick={() => handleCopy('citationPass', formData.citationPass)}
                                        >
                                             Copy
                                        </div>
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">email</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name=" citationEmail"
                                             value={formData.citationEmail}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationEmail: e.target.value }))
                                             }
                                        />
                                        <div
                                             className={`btn ${copyClicked === 'citationEmail' ? 'btn-warning' : 'btn-navy'}`}
                                             onClick={() => handleCopy('citationEmail', formData.citationEmail)}
                                        >
                                             Copy
                                        </div>
                                   </div>
                                   <div className="col-24 d-flex align-items-center gap-2">
                                        <label className="col-12 text-end pe-3 fw-bold text-capitalize">Get Email</label>
                                        <input
                                             className="form-control"
                                             type="text"
                                             name="citationEmailLocation"
                                             value={formData.citationEmailLocation}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, citationEmailLocation: e.target.value }))
                                             }
                                        />
                                        <div
                                             className={`btn ${copyClicked === 'citationEmailLocation' ? 'btn-warning' : 'btn-navy'}`}
                                             onClick={() => handleCopy('citationEmailLocation', formData.citationEmailLocation)}
                                        >
                                             Copy
                                        </div>
                                   </div>
                              </div>
                              {/* Row 9 (Note field) */}
                              <div className="row g-3 mb-3 mt-3">
                                   <div className="col-48 ps-3">
                                        <label className='fw-bold'>Note</label>
                                   </div>
                                   <div className="col-48 d-flex align-items-center gap-2">
                                        <textarea
                                             className='form-control'
                                             name="Notes"
                                             id="Notes"
                                             rows="6"
                                             value={formData.Notes}
                                             onChange={(e) =>
                                                  setFormData(prev => ({ ...prev, Notes: e.target.value }))
                                             }
                                        />
                                   </div>
                              </div>

                         </>
                    )}

                    {deleteError && <div className="alert alert-danger" role="alert">{deleteError}</div>}
                    <div className="custom-modal-footer d-flex justify-content-end align-items-center gap-2 mt-4">
                         <div className="col-24 d-flex align-items-center gap-2">
                              <button type="button" className="btn btn-danger mt-3" disabled={isDeleting || isSaving} onClick={handleDelete}>
                                   {isDeleting ? 'Deleting…' : 'Delete Citation'}
                              </button>
                              <button className="btn btn-warning mt-3" disabled={isDeleting || isSaving} onClick={() => setShowModal(true)}>
                                   Create Follow Up
                              </button>
                         </div>
                         <div className="col-24 d-flex gap-2 justify-content-end pe-2">
                              <button className="btn btn-secondary" disabled={isDeleting || isSaving} onClick={onClose}>Cancel</button>
                              <button className="btn btn-success text-light fw-bold" disabled={isDeleting || isSaving} onClick={() => handleSave()}>Save Changes</button>
                         </div>
                    </div>
               </div>
               {showModal && (
               <CreateFollowUp
                    currentDateValue={currentDateValue}
                    setCurrentDate={setCurrentDate}
                    closeModal={() => setShowModal(false)}
                    defaultTitle={`${activeClient.companyName} Follow Up`}
                    defaultMessage={`${citation.Domain} Citation ${citation.ID} Follow Up`}
               />
          )}
          </div>
         

     );
};

export default EditCitationModal;
